import { Module } from 'vuex';

import { RootState } from 'frontend/types';

interface IsFirstCourseState {
  didNotStartALesson: boolean;
}

const isFirstCourse: Module<IsFirstCourseState, RootState> = {
  namespaced: true,
  state: {
    didNotStartALesson: false,
  },
  mutations: {
    setValue(state: IsFirstCourseState, value: { is_first_course: boolean }): void {
      state.didNotStartALesson = value.is_first_course;
    },
  },
};

export default isFirstCourse;
